(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9653],{

/***/ 59653:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ shopsView; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./lib/getLinkProps.js
var getLinkProps = __webpack_require__(89729);
// EXTERNAL MODULE: ./components/index.js + 177 modules
var components = __webpack_require__(74030);
// EXTERNAL MODULE: ./components/shopsView/ShopsView.module.scss
var ShopsView_module = __webpack_require__(24037);
var ShopsView_module_default = /*#__PURE__*/__webpack_require__.n(ShopsView_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/shopsView/ShopsView.js



/* eslint-disable react/button-has-type */







var ShopsViews = function ShopsViews(_ref) {
  var isStatic = _ref.isStatic;

  var _getLinkProps = (0,getLinkProps/* default */.Z)({
    type: 'shops-map'
  }),
      _getLinkProps2 = (0,slicedToArray/* default */.Z)(_getLinkProps, 2),
      shopsMapHref = _getLinkProps2[0],
      shopsMapAs = _getLinkProps2[1];

  var _getLinkProps3 = (0,getLinkProps/* default */.Z)({
    type: 'shops-list'
  }),
      _getLinkProps4 = (0,slicedToArray/* default */.Z)(_getLinkProps3, 2),
      shopsListHref = _getLinkProps4[0],
      shopsListAs = _getLinkProps4[1];

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: (0,clsx_m/* default */.Z)((0,defineProperty/* default */.Z)({}, (ShopsView_module_default()).isStatic, isStatic), (ShopsView_module_default()).views),
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (ShopsView_module_default()).tabs,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (ShopsView_module_default()).buttons,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* ActiveLink */.O$, {
          activeClassName: (ShopsView_module_default()).active,
          href: shopsListHref,
          as: shopsListAs,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Control */.oT, {
            className: (ShopsView_module_default()).button,
            tag: "a",
            children: "\u0421\u043F\u0438\u0441\u043E\u043A"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ActiveLink */.O$, {
          activeClassName: (ShopsView_module_default()).active,
          href: shopsMapHref,
          as: shopsMapAs,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Control */.oT, {
            className: (ShopsView_module_default()).button,
            tag: "a",
            children: "\u041D\u0430 \u043A\u0430\u0440\u0442\u0435"
          })
        })]
      })
    })
  });
};

/* harmony default export */ var ShopsView = (ShopsViews);
;// CONCATENATED MODULE: ./components/shopsView/index.js

/* harmony default export */ var shopsView = (ShopsView);

/***/ }),

/***/ 24037:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"views":"ShopsView_views__pgE2L","isStatic":"ShopsView_isStatic__fAbk_","buttons":"ShopsView_buttons__d_Zk2","tabs":"ShopsView_tabs__PDKeA","load":"ShopsView_load___Xzso"};

/***/ })

}]);